import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { Baby } from "../requests";
import { Link } from "react-router-dom";

const BabyDetails = (props) => {
  const [diapers, setDiapers] = useState();
  const [formula, setFormula] = useState();

  // console.log(props);

  const bDetails = {
    date_of_birth: props.date_of_birth,
    diapers: props.diapers,
    formula: props.formula,
    formula_amount: props.formula_amount,
    formula_type: props.formula_type,
    id: props.id,
    name: props.name,
  };

  const confirmDiapers = (id, params) => {
    Baby.update(id, params).then((b) => {
      setDiapers(b.diapers);
    });
  };
  const confirmFormula = (id, params) => {
    Baby.update(id, params).then((b) => {
      setFormula(b.formula);
    });
  };

  let nowDate = new Date(new Date().setHours(0, 0, 0, 0));
  let dob = new Date(props.date_of_birth);

  let years = nowDate.getFullYear() - dob.getFullYear();
  let months = nowDate.getMonth() - dob.getMonth();
  let days = nowDate.getDate() - dob.getDate();

  if (days < 0) {
    months -= 1;
  }

  let ageInMonths = (months += years * 12);

  return (
    <tbody className="border-dark">
      <tr>
        <td className="text-center align-middle">{props.name}</td>
        <td className="text-center align-middle">{ageInMonths} months</td>
        <td className="text-center align-middle">{props.date_of_birth}</td>
        <td className="text-center align-middle">{diapers ? diapers : props.diapers}</td>
        <td className="text-center align-middle">{formula ? formula : props.formula}</td>
        <td className="text-center align-middle">{props.formula_type}</td>
        <td className="text-center align-middle">{props.formula_amount}</td>
        {props.currentUser?.admin ? (
          <>
            <td>
              <Button
                onClick={() =>
                  confirmDiapers(props.id, { diapers: new Date() })
                }
                variant="success"
              >
                Confirm Diapers
              </Button>
            </td>
            <td>
              <Button
                onClick={() =>
                  confirmFormula(props.id, { formula: new Date() })
                }
                variant="success"
              >
                Confirm Formula
              </Button>
            </td>
            <td>
              <Link
                to={`/babies/${props.id}/edit`}
                state={{ fromBabyDetails: bDetails }}
                className="btn btn-success"
              >
                Edit Baby
              </Link>
            </td>
            <td>
              <Button
                onClick={() => props.deleteBaby(props.id)}
                variant="outline-danger"
              >
                Delete Baby
              </Button>
            </td>
          </>
        ) : (
          ""
        )}
      </tr>
    </tbody>
  );
};

export default BabyDetails;
